'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _shortid = require('shortid');
var _shortid2 = _interopRequireDefault(_shortid);
var _EmailShare = require('./EmailShare');
var _EmailShare2 = _interopRequireDefault(_EmailShare);
var _FacebookShare = require('./FacebookShare');
var _FacebookShare2 = _interopRequireDefault(_FacebookShare);
var _TwitterShare = require('./TwitterShare');
var _TwitterShare2 = _interopRequireDefault(_TwitterShare);
var _PinterestShare = require('./PinterestShare');
var _PinterestShare2 = _interopRequireDefault(_PinterestShare);
var _Print = require('./Print');
var _Print2 = _interopRequireDefault(_Print);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Social = function (_React$Component) {
  _inherits(Social, _React$Component);
  function Social() {
    _classCallCheck(this, Social);
    var _this = _possibleConstructorReturn(this, (Social.__proto__ || Object.getPrototypeOf(Social)).call(this));
    _this.generateComponent = _this.generateComponent.bind(_this);
    return _this;
  }
  _createClass(Social, [{
    key: 'generateComponent',
    value: function generateComponent(service) {
      switch (service) {
        case 'facebook':
          return _react2.default.createElement(_FacebookShare2.default, {
            key: _shortid2.default.generate(),
            appId: this.props.facebookAppId,
            icon: this.props.facebookIcon,
            image: this.props.facebookImage,
            message: this.props.facebookMessage,
            subject: this.props.facebookSubject,
            url: this.props.facebookUrl
          });
        case 'email':
          return _react2.default.createElement(_EmailShare2.default, {
            key: _shortid2.default.generate(),
            message: this.props.emailMessage,
            subject: this.props.emailSubject,
            url: this.props.emailUrl
          });
        case 'twitter':
          return _react2.default.createElement(_TwitterShare2.default, {
            key: _shortid2.default.generate(),
            icon: this.props.twitterIcon,
            message: this.props.twitterMessage,
            url: this.props.twitterUrl
          });
        case 'pinterest':
          return _react2.default.createElement(_PinterestShare2.default, {
            key: _shortid2.default.generate(),
            icon: this.props.pinterestIcon,
            image: this.props.pinterestImage,
            url: this.props.pinterestUrl,
            message: this.props.pinterestMessage
          });
        case 'print':
          return _react2.default.createElement(_Print2.default, {
            key: _shortid2.default.generate()
          });
        default:
          return null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;
      return _react2.default.createElement('div', {
        className: 'social ' + this.props.className
      }, this.props.services.map(function (service) {
        return _this2.generateComponent(service);
      }));
    }
  }]);
  return Social;
}(_react2.default.Component);
Social.defaultProps = {
  className: '',
  emailMessage: 'Email Message',
  emailSubject: 'Email Subject',
  emailUrl: window.location.href,
  facebookAppId: '',
  facebookIcon: 'default',
  facebookImage: window.location.origin + '/images/share-image.jpg',
  facebookMessage: 'Facebook Message',
  facebookSubject: 'Facebook Subject',
  facebookUrl: window.location.href,
  pinterestIcon: 'default',
  pinterestImage: window.location.origin + '/images/share-image.jpg',
  pinterestMessage: 'Pinterest Message',
  pinterestUrl: window.location.href,
  twitterIcon: 'default',
  twitterMessage: 'Twitter Message',
  twitterUrl: window.location.href,
  services: ['twitter', 'facebook', 'email']
};
Social.propTypes = {
  className: _propTypes2.default.string,
  emailSubject: _propTypes2.default.string,
  emailMessage: _propTypes2.default.string,
  emailUrl: _propTypes2.default.string,
  facebookAppId: _propTypes2.default.string,
  facebookIcon: _propTypes2.default.oneOf(['default', 'square']),
  facebookImage: _propTypes2.default.string,
  facebookMessage: _propTypes2.default.string,
  facebookSubject: _propTypes2.default.string,
  facebookUrl: _propTypes2.default.string,
  pinterestIcon: _propTypes2.default.oneOf(['default', 'p', 'square']),
  pinterestImage: _propTypes2.default.string,
  pinterestMessage: _propTypes2.default.string,
  pinterestUrl: _propTypes2.default.string,
  twitterIcon: _propTypes2.default.oneOf(['default', 'square']),
  twitterMessage: _propTypes2.default.string,
  twitterUrl: _propTypes2.default.string,
  services: _propTypes2.default.arrayOf(_propTypes2.default.oneOf(['email', 'facebook', 'pinterest', 'print', 'twitter']))
};
exports.default = Social;